import type { ChatMessage } from '@mem-ai-hub/shared';
import { apiClient } from './api';

/**
 * Record or clear a user's thumbs-up / thumbs-down on an assistant message.
 * Pass `rating: null` to clear existing feedback. An optional `comment` is only
 * meaningful for a thumbs-down. Returns the updated message.
 */
export function setFeedback(
  sessionId: string,
  messageId: string,
  rating: 'up' | 'down' | null,
  comment?: string,
): Promise<ChatMessage> {
  return apiClient.put<ChatMessage>(
    `/chat/sessions/${sessionId}/messages/${messageId}/feedback`,
    { rating, ...(comment ? { comment } : {}) },
  );
}
